import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Input } from '@/components/ui/input';
import { Lock, Mail } from 'lucide-react';

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/logo-cropped.png" alt="SISL" className="h-16 mx-auto mb-4 object-contain" />
          <h1 className="text-xl font-bold text-white">Admin Dashboard</h1>
          <p className="text-sm text-[#666] mt-1">Score Integrated Solutions LLC</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-[#161616] border border-white/10 p-8 space-y-5" data-testid="admin-login-form">
          {error && <div className="text-red-400 text-sm bg-red-400/10 border border-red-400/20 p-3">{error}</div>}
          <div>
            <label className="text-xs uppercase tracking-widest text-[#888] font-bold mb-2 block">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555]" />
              <Input value={email} onChange={e => setEmail(e.target.value)} type="email" required placeholder="admin@company.com" className="bg-transparent border-white/10 text-white pl-10 h-11 focus:border-[#F2B705]" data-testid="admin-email-input" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-[#888] font-bold mb-2 block">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555]" />
              <Input value={password} onChange={e => setPassword(e.target.value)} type="password" required placeholder="Password" className="bg-transparent border-white/10 text-white pl-10 h-11 focus:border-[#F2B705]" data-testid="admin-password-input" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-[#F2B705] text-black font-bold text-sm uppercase tracking-wide py-3 hover:bg-[#D9A404] transition-colors disabled:opacity-50">
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}
